import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateInvoluntaryRetrenchmentQuote } from '../../shared/models/create-involuntary-retrenchment-quote';
import { environment } from '../../../environments/environment';
import {
    InvoluntaryRetrenchmentQuote,
    InvoluntaryRetrenchmentQuoteResponse,
} from '../../shared/models/quote';
import { InvoluntaryRetrenchmentReport } from '../../shared/models/report';

interface InvoluntaryReportResponse {
    message: string;
    policyList: InvoluntaryRetrenchmentReport[];
}

interface InvoluntaryRetrenchmentQuotesResponse {
    message: string;
    quotes: InvoluntaryRetrenchmentQuote[];
}

export interface FailedUploadRecord {
    rowNumber: number;
    nationalId: string;
    fullName: string;
    errorMessage: string;
}

export interface InvoluntaryRetrenchmentUploadResponse {
    totalRecords: number;
    successfulRecords: number;
    failedRecords: number;
    status: string;
    message: string;
    failedRecordsArray: FailedUploadRecord[];
}

export interface InvoluntaryRetrenchmentUploadRequest {
    currencyId: number;
    employerSectorId: number;
    employerType: string;
    employerName: string;
    paymentFrequency: string;
    startDate: string;
}

@Injectable({
    providedIn: 'root',
})
export class InvoluntaryRetrenchmentService {
    private baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) {}

    createInvoluntaryRetrenchmentQuote(
        quote: CreateInvoluntaryRetrenchmentQuote
    ): Observable<InvoluntaryRetrenchmentQuoteResponse> {
        return this.http.post<InvoluntaryRetrenchmentQuoteResponse>(
            this.baseUrl + '/api/involuntary-retrenchment',
            quote
        );
    }

    fetchInvoluntaryRetrenchmentQuote(
        quoteId: number
    ): Observable<InvoluntaryRetrenchmentQuoteResponse> {
        return this.http.get<InvoluntaryRetrenchmentQuoteResponse>(
            this.baseUrl + '/api/involuntary-retrenchment/' + quoteId
        );
    }

    approveInvoluntaryRetrenchmentQuote(
        quoteId: number,
        payload: any
    ): Observable<any> {
        return this.http.put<any>(
            this.baseUrl +
                '/api/involuntary-retrenchment/' +
                quoteId +
                '/approve',
            payload
        );
    }

    fetchAllCustomerQuotes(customerId: number) {
        return this.http.get<any>(
            this.baseUrl +
                '/api/involuntary-retrenchment/search?customerId=' +
                customerId
        );
    }

    uploadPolicies(
        file: File,
        request: InvoluntaryRetrenchmentUploadRequest
    ):Observable<InvoluntaryRetrenchmentUploadResponse> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append(
            'request',
            new Blob([JSON.stringify(request)], { type: 'application/json' })
        );
        return this.http.post<InvoluntaryRetrenchmentUploadResponse>(
            this.baseUrl + '/api/involuntary-retrenchment/upload',
            formData
        );
    }

    generateReport(reportPayload: any): Observable<InvoluntaryReportResponse> {
        return this.http.post<InvoluntaryReportResponse>(
            this.baseUrl + '/api/report/involuntary-retrenchment',
            reportPayload
        );
    }
}
